export default {
    ai: 'Assistente de IA',
    export: 'Exportar',
    blue: 'Azul',
    yellow: 'Amarelo',
    pink: 'Rosa',
    orange: 'Laranja',
    all: 'Tudos',
    generateApaCopy: 'Gerar citação APA',
    apaCopied: 'Citação copiada para o clipboard!',
    imReading: 'Estou lendo',
    in: 'em',
    by: 'Por',
    article: 'Artigo',
    prevArticle: 'Artigo anterior',
    nextArticle: 'Artigo seguinte',
    imHere: `Sim, estou aqui`,
    sessionExpiredAlert: 'Sua sessão de leitura está prossima a terminar.',
    sessionExpiredAreYouThere: 'Você está aí?',
    sessionExpired: 'Sua sessão de leitura expirou devido a inatividade.',
    returnToLibrary: 'Voltar para a biblioteca',
    sessionValidExpired: 'Sessão expirada',
    sessionValidExpiredPleaseLoginAgain: 'Por favor faça o login novamente',
    tableOfContents: 'Sumário',
    tableOfContentsNotAvailable: 'Nenhum índice disponível.',
    pages: 'páginas',
    page: 'página',
    thumbnails: 'Miniaturas',
    settings: 'Configurações',
    bookmarks: 'Favoritos',
    highlights: 'Destacados',
    highlight: 'Destacado',
    notes: 'Notas',
    note: 'Nota',
    notebook: 'Apontador',
    search: 'Pesquisar',
    theme: 'Tema',
    pageLayout: 'Layout da página',
    typography: 'Tipografia',
    fontDefault: 'Padrão',
    lineSpacing: 'Espaçamento entre linhas',
    lineSpacingCompact: 'Compacto',
    lineSpacingNormal: 'Normal',
    lineSpacingWide: 'Amplo',
    margins: 'Margens',
    marginsMinimum: 'Mínimo',
    marginsNormal: 'Normal',
    marginsMaximum: 'Máximo',
    readingModes: 'Modos de leitura',
    zoomTitle: 'Tamanho do texto',
    zoomTitlePdf: 'Zoom',
    zoomTimes: 'Times',
    continuous: 'Contínuo',
    onePage: 'Horizontal',
    onePageScroll: 'Vertical',
    twoPages: 'Dupla',
    twoPagesScroll: 'Rolagem de duas páginas',
    citation: {
        buttons: {
            Iso690: 'Gerar citação ISO690',
            APA: 'Gerar citação APA',
            Vancouver: 'Gerar citação Vancouver',
            Chicago: 'Gerar citação Chicago',
            ChicagoNotes: 'Notas',
            ChicagoBibliography: 'Bibliografia',
            ChicagoAuthorDate: 'Autor-Data',
            IEEE: 'Gerar citação IEEE',
            MLA: 'Gerar citação MLA',
            ABNT: 'Gerar citação ABNT',
        },
        menu: {
            title: 'Gerar citação',
            Iso690: 'Citação ISO690',
            APA: 'Citação APA',
            Vancouver: 'Citação Vancouver',
            Chicago: 'Citação Chicago',
            ChicagoNotes: 'Notas',
            ChicagoBibliography: 'Bibliografia',
            ChicagoAuthorDate: 'Autor-Data',
            IEEE: 'Citação IEEE',
            MLA: 'Citação MLA',
            ABNT: 'Citação ABNT',
        },
        messages: {
            copied: 'Citação copiada para o clipboard!',
            availableIn: 'Disponível em',
            online: 'Em linha',
            generated: 'cited',
            websiteName: 'publica.la',
            and: 'e',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Explicar conceito',
            expand: 'Expandir informação',
            summarize: 'Resumir ideia',
        },
        menu: {
            title: 'Asistente de IA (Beta)',
        },
        messages: {
            copied: '¡Resposta copiada para a área de transferência!',
            addedToResponse: '«Resposta copiada do publica.la Reader»',
        },
        thanksFeedback: 'Obrigado pelo seu feedback!',
        errorFeedback: 'Falha ao enviar feedback. Pode tentar novamente?',
    },
    onlyCopy: 'Copiar texto simples',
    translate: 'Traduzir',
    copy: 'copiar',
    changeColor: 'Mudar cor',
    socialShare: 'Compartilhar',
    zoom: {
        auto: 'Auto',
        'page-fit': 'Ajuste da página',
        'page-width': 'Largura da página',
    },
    filter: 'Filtro',
    noFilterHighlights: 'Selecione um cor para ver seus destaques',
    noFilterHighlightsColor: 'Não há nada destacado nesta cor',
    noHighlights: 'Você ainda não fez nenhum destaque',
    noFilterNotes: 'Selecione um cor para ver suas anotações',
    noFilterNotesColor: 'Não há notas nesta cor',
    noNotes: 'Você ainda não escreveu nenhuma nota',
    noFilterHighlightsAndNotes: 'Selecione um cor para ver seus destaques e notas',
    noFilterHighlightsAndNotesColor: 'Não há notas ou destaques nesta cor',
    noHighlightsAndNotes: 'Você ainda não criou destaques ou notas',
    plainCopied: 'Texto copiado para o clipboard!',
    onboarding: {
        next: 'Próximo',
        finish: 'Terminar',
        skip: 'Pular tutorial',
        previous: 'Anterior',
        reader: {
            welcome: {
                title: 'Bem-vindo ao seu espaço de leitura',
                paragraph:
                    'Descubra como tirar o máximo proveito dos seus livros com as ferramentas disponíveis no leitor.',
                extraParagraph: 'Aproveite seu novo espaço de leitura!',
            },
            highlights: {
                title: 'Melhore sua experiência de leitura',
                paragraph:
                    'Selecione texto, destaque, crie notas, gere citações, traduza e ouça o conteúdo. Leve sua experiência de leitura ao próximo nível em todos os formatos.',
            },
            resumes: {
                title: 'Gerencie seu conteúdo',
                paragraph:
                    'Aumente sua produtividade. Gerencie suas notas, destaques, citações e resumos de acordo com sua conveniência. Compartilhe suas ideias de forma rápida e fácil.',
            },
            appPromote: {
                title: 'Leia ou ouça em qualquer lugar',
                paragraph:
                    'Acesse seu conteúdo quando e como quiser, sem necessidade de conexão à internet, no dispositivo de sua preferência.',
                extraParagraph: 'Baixe nosso app!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Bem-vindo',
                subTitle: 'Como usar o player?',
                paragraph: 'Aprenda a usar as funções e aproveitar ao máximo o player.',
            },
            reproduction: {
                title: 'Controle de reprodução',
                paragraph: 'Avançar, voltar ou pausar a reprodução do audiolivro',
            },
            narratorSpeed: {
                title: 'Aumentar e reduzir a velocidade da narração',
                paragraph: 'Você pode escolher a velocidade com a qual o audiobook é escutado, como você preferir.',
            },
            chapters: {
                title: 'Avançar e retornar em capítulos',
                paragraph: 'Navegue entre capítulos de maneira ágil e rápida.',
            },
        },
    },
    author: 'Autor',
    publisher: 'Publisher',
    narrator: 'Narrador',
    narratedBy: 'Narrado por',
    aboutThisPublication: 'Sobre esta publicação',
    listening: {
        label: 'Ouvir',
        voice: 'Voz',
    },
    searchResultEmpty: 'Nenhum resultado encontrado',
    searchLengthError: 'A pesquisa deve ter entre 4 e 128 caracteres',
    keepTyping: 'Continue digitando…',
    loading: 'Carregando...',
    searchLoading: 'Procurando...',
    searchTitle: 'Buscador',
    lastSearch: 'Sugestões',
    searchExplanation: 'Encontre palavras de forma ágil em todas as publicações',
    networkIsOffline: 'Nenhuma conexão com a internet disponível. Alguns recursos estão indisponíveis.',
    about: 'Sobre',
    chapters: 'Capítulos',
    duration: 'Duração',
    narratorSpeed: 'Velocidade do narrador',
    slowNarration: 'Narração lenta',
    normalNarration: 'Narração normal',
    fastNarration: 'Narração rapida',
    shareIssue: 'Compartilhar publicação',
    shareArticle: 'Compartilhar artigo',
    copyUrl: 'Copiar URL',
    shareCurrentPage: 'Compartilhar página atual',
    shareCurrentPosition: 'Compartilhar posição atual',
    copyUrlToClipboard: 'URL copiado para a área de transferência',
    tooltips: {
        zoomOut: 'Reduzir o zoom',
        zoomIn: 'Mais Zoom',
        config: 'Configuração',
        tableOfContents: 'Índice',
        search: 'Pesquisar',
        highlights: 'Destacados',
        notebook: 'Apontador',
        listen: 'Ouvir',
        bookmarks: 'Favoritos',
        openThumbnails: 'Miniaturas',
        closeThumbnails: 'Miniaturas de saída',
        download: 'Acesso offline',
        share: 'Compartilhar',
        prev: 'Anterior',
        next: 'Próximo',
        close: 'Fechar',
        back: 'De volta',
        themeTitle: 'Aparência',
        themeLight: 'Luz',
        themeDark: 'Sombrio',
        themeCream: 'Creme',
        themeSepia: 'Sépia',
        themeCyan: 'Ciano',
        themeHighContrast: 'Alto contraste',
        themeHighContrastDark: 'Alto contraste escuro',
        clear: 'Claro',
        citation: 'Citação',
        dictionary: 'Dicionário',
        aiIntegrations: 'Asistente de IA (Beta)',
        aiAction:
            'Esta ferramenta usa IA, portanto pode haver informações imprecisas. Mais melhorias em breve! O que você acha? Use os ícones abaixo para compartilhar seus pensamentos.',
        translate: 'Traduzir',
        about: 'Sobre',
        rewind: 'Rebobinar',
        forward: 'Ultrapassagem',
        createNote: 'Criar uma anotação',
        createHighlight: 'Realçar',
        deleteHighlight: 'Excluir destaque',
        help: 'Ajuda',
        lists: 'Listas',
        copy: 'Copiar',
        goodResponse: 'Boa resposta',
        badResponse: 'Má resposta',
        ai: 'Assistente IA',
        moreActions: 'Mais ações',
        moreOptions: 'Mais opções',
        play: 'Reproduzir',
        pause: 'Pausar',
        seekPosition: 'Posição da faixa',
        zoomReset: 'Redefinir zoom',
        smartZoom: 'Smart Zoom',
        themeSystem: 'Tema do sistema',
        searchInBook: 'Pesquisar no livro',
        pageSlider: 'Navegação de página',
    },
    save: 'Salvar',
    delete: 'Excluir',
    cancel: 'Cancelar',
    confirmDelete: {
        title: 'Excluir anotação',
        message: 'Tem certeza de que deseja excluir esta anotação? Esta ação não pode ser desfeita.',
    },
    confirmResetSettings: {
        title: 'Restaurar padrões',
        message: 'Todas as configurações visuais serão restauradas para os valores padrão.',
    },
    resetSettings: 'Restaurar padrões',
    writeNote: 'Escreva uma nota',
    speakNow: 'Fale agora',
    listeningSpeech: 'Ouvindo',
    share: {
        copyShare: 'Copiar e compartilhar',
        qrCodeTitle: 'Código QR',
        scanQr: 'Digitalize o código QR usando seu aplicativo WeChat',
        copyLink: 'Copie o URL da publicação',
        copy: 'Copiar',
        copied: 'copiado!',
        openWechat: 'Abrir aplicativo WeChat',
        openingWechat: 'Abrindo o aplication WeChat...',
        sendCopiedUrl: 'Enviar URL copiado para um contato',
    },
    playing: 'Reproduzindo',
    buyNow: 'Compre Agora',
    buyNowText: 'Adquira a versão completa.',
    preview: 'Amostra',
    changeLayoutNotAllowed: 'O conteúdo não permite alterar o layout da página',
    nativeTtsLang: {
        'en-US': 'Inglês (Estados Unidos)',
        'en-GB': 'Inglês (Reino Unido)',
        'en-scotland': 'Inglês (Escócia)',
        'en-AU': 'Inglês (Austrália)',
        'en-IE': 'Inglês (Irlanda)',
        'en-IN': 'Inglês (Índia)',
        'en-ZA': 'Inglês (África do Sul)',
        en: 'Inglês',
        'es-AR': 'Espanhol (Argentina)',
        'es-ES': 'Espanhol (Espanha)',
        'es-MX': 'Espanhol (México)',
        'es-US': 'Espanhol (Estados Unidos)',
        es: 'Espanhol',
        'it-IT': 'Italiano (Itália)',
        it: 'Italiano',
        'pt-PT': 'Português (Portugal)',
        'pt-BR': 'Português (Brasil)',
        pt: 'Português',
        'fr-CA': 'Francês (Canadá)',
        'fr-FR': 'Francês (França)',
        fr: 'Francês',
        pl: 'Polaco',
        'pl-PL': 'Polaco (Polonia)',
    },
    promoteApp: {
        downloadAppStore: 'Baixar na App Store',
        downloadPlayStore: 'Disponível no Google Play',
        title_read: 'Leve a sua leitura com você aonde você for com',
        title_audio: 'Leve seus audiolivros com você aonde você for com',
        text: 'Tenha acesso ao seu conteúdo quando e como quiser, sem precisar de conexão com a internet, no dispositivo de sua preferência. Baixe nosso aplicativo!',
        title_first_part: 'Com',
        title_second_part: 'leve suas leituras para onde você for',
    },
    dictionary: 'Dicionário',
    selectionTooLongLine1: 'A seleção contém muitas palavras.',
    selectionTooLongLine2: 'Tente selecionar até 5 palavras.',
    dictionaryValidation: {
        message: 'Você selecionou {count} palavras.\nPor favor, tente selecionar até {max} palavras.',
    },
    translateValidation: {
        message: 'Você selecionou {count} caracteres.\nPor favor, tente selecionar até {max} caracteres.',
    },
    ttsValidation: {
        message: 'Você selecionou {count} caracteres.\nPor favor, tente selecionar até {max} caracteres.',
    },
    aiValidation: {
        message: 'Você selecionou {count} caracteres.\nPor favor, selecione entre {min} e {max} caracteres.',
    },
    alreadyPurchased: 'Já comprou?',
    logIn: 'Iniciar sessão',
    addToAList: 'Adicionar a uma lista',
    lists: 'Listas',
    nextSection: 'Próxima seção',
    prevSection: 'Seção anterior',
    new: 'Novo',
    skipLinks: {
        navLabel: 'Links de acesso rápido',
        showControls: 'Mostrar controles',
    },
    accessibility: {
        textSelected: '{count} caracteres selecionados. Ferramentas de seleção disponíveis.',
        pageChanged: 'Página {current} de {total}',
    },
};
